import { render } from "./BottomComponent.vue?vue&type=template&id=4a637458"
import script from "./BottomComponent.vue?vue&type=script&lang=js"
export * from "./BottomComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__